<template>
  <DataTable :id="'table-'+tableId"
      :ref="'table'"
      :columns="columns"
      :options="options"
      :data="data"
      class="table w-100"
      width="100%"
  ></DataTable>
</template>

<script>
import store from "@/store";


import DataTable from 'datatables.net-vue3';
import {makeCode} from "@/shared/helper";
export default {
  name: "LocalDataTable",
  components:{DataTable},
  props : ['columns','ajaxLink','data','functions','orderColumn','orderType','initDocument'],
  beforeMount()
  {
    this.initPage();
  },
  mounted(){
    const table = this.$refs.table;
    this.table = table.dt();
    const self = this;
    const $ = window.$;
      $(document).ready(function ()
      {
        $(this).delegate('#table-'+self.tableId+' .method', 'click', function ()
        {
          const methodName = $(this).data('name');
          let methodParams = $(this).data('params');
          if (!methodParams)
            methodParams = [];
          else
            methodParams = methodParams.split('|');

          if (self.functions && Array.isArray(self.functions))
          {
            for (let i = 0; i < self.functions.length; i++)
            {
              const a = self.functions[i];
              if (a.name === methodName && typeof a.method === "function")
              {
                methodParams.push(this);
                a.method(...methodParams);
              }
            }
          }
        });
        $(this).delegate('#table-'+self.tableId+' .router-link', 'click', function (event)
        {
          event.preventDefault();
          const to = $(this).attr('href');
          if (to)
          {
            self.$router.push({path: to})
          }

        })
      });

  },
  data: function() {
    return {
      ajax : null,
      loaded : true,
      token :null,
      options : {},
      table : null,
      tableId:makeCode(16)
    }
  },
  methods : {
    initPage()
    {
      const self = this;

      // let order_type = this.orderType;
      // //orderType [desc,acs]
      // if (order_type === 1 )
      //   order_type = 'acs';
      // else
      //   order_type = 'desc';

      //asc desc
      let order_array = [[0, 'desc']];
      if (this.orderType && this.orderColumn)
      {
        order_array = [[this.orderColumn, this.orderType]]
      }

      const authData = store.getters["auth/getAuthData"];
      this.token = authData.token;
      this.options = {
        order: order_array,
        drawCallback : function (){
        },
        dom: "<\'row\'<\'col-sm-6\'l><\'col-sm-6\'f>>" +
            "<\'table-responsive\'tr>" +
            "<\'row\'<\'col-sm-5\'i><\'col-sm-7 mt-2\'p>>",
        processing: true,
        language: {
          "decimal":        "",
          "emptyTable":     "هیچ رکوردی برای نمایش وجود ندارد",
          "info":           "نمایش _START_ تا _END_ از _TOTAL_ مورد",
          "infoEmpty":      "",
          "infoFiltered":   "(فیلتر شده از مجموع _MAX_ مورد)",
          "infoPostFix":    "",
          "thousands":      ",",
          "lengthMenu":     "نمایش _MENU_ مورد",
          "loadingRecords": "درحال بارگذاری...",
          "processing":     "درحال پردازش...",
          "search":         "جستجو:",
          "zeroRecords":    "هیچ رکودری یافت نشد",
          paginate: {
            previous: '<i class="fa fa-angle-right" aria-hidden="true"></i>',
            next:'<i class="fa fa-angle-left" aria-hidden="true"></i>'
          }}
      };
      // if (this.orderColumn)
      // {
      //   if (!isNaN(this.orderColumn))
      //   {
      //     this.options.order = [[this.orderColumn, order_type]];
      //   }
      // }
      // else
      //   this.options.order = [[0, 'desc']];
      if (this.ajaxLink)
      {
        this.options.serverSide = true;
        this.options.ajax = {
          url: process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PATH + this.ajaxLink,
          type: "GET",
          headers: {'Authorization': `bearer ${this.token}`},
        };
      }
    },
  },
  watch:{
    ajaxLink:{
      handler()
      {
        const url= process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PATH + this.ajaxLink;
        this.table.ajax.url(url).load()
        // this.table.draw();
      },deep : true
    }
  }
}

</script>
<style scoped>
@import "../../public/css/datatable.css";
@import "../../public/css/datatableadd.css";

</style>
